/**
 * 公式预设兜底清单
 * 当后端 /formula/index 接口不可用或返回空时使用
 * 与数据库 sys_bankflow_formula 表结构一致：{ name, content, category, sort }
 *
 * 公式语法（用反斜杠 \...\ 整体包裹，反斜杠需用户自己输入）：
 *   t/yyyyMMdd/      日期，支持 yyyy MM dd 任意组合，如 t/yyyy-MM-dd/
 *   (n)              n 位随机数字
 *   {n}              n 位随机小写字母
 *   <n>              n 位随机大写字母
 *   [n]              n 位 数字+大写字母
 *   `n`              n 位 数字+小写字母
 *   {姓名}           随机姓名
 *   c/字段名/        引用本条记录的某个字段值，如 c/counterparty_name/
 *
 * 示例：\5301000048400220t/yyyyMMdd/(10)\
 */
export const formulaPresets = [
  // 日期
  { name: '日期 yyyyMMdd', content: 't/yyyyMMdd/', category: '日期', sort: 1 },
  { name: '日期 yyyy-MM-dd', content: 't/yyyy-MM-dd/', category: '日期', sort: 2 },
  { name: '日期 yyyyMM', content: 't/yyyyMM/', category: '日期', sort: 3 },
  { name: '日期 MMdd', content: 't/MMdd/', category: '日期', sort: 4 },
  { name: '日期 yyyy', content: 't/yyyy/', category: '日期', sort: 5 },
  // 随机数字（位数自行修改）
  { name: '随机数字', content: '(10)', category: '随机数字', sort: 12 },
  // 字母（位数自行修改）
  { name: '随机字母', content: '{6}', category: '字母', sort: 20 },
  // 姓名
  { name: '随机姓名', content: '{姓名}', category: '姓名', sort: 30 },
  // 列引用
  { name: '引用-交易对方', content: 'c/counterparty_name/', category: '列引用', sort: 40 },
  { name: '引用-商户单号', content: 'c/merchant_order_no/', category: '列引用', sort: 41 },
  { name: '引用-备注', content: 'c/remark/', category: '列引用', sort: 42 }
]

